import React from "react";
import "./HeaderTable.scss";

function Header({ columns }) {
  return (
    <thead>
      <tr>
        {columns.map((column, index) => (
          <th className="headerTableText" key={"header" + index}>
            {column}
          </th>
        ))}
        <th></th>
      </tr>
    </thead>
  );
}
export default Header;
